<div class="modal-body">
  <div class="row col-12">
    <div class="divformlabel">
      <label> {{ "CaseClassification" | translate }} </label>
      <span *ngIf="CaseCategory.invalid" class="alert error-span">
        <div *ngIf="CaseCategory.errors?.required">*</div>
      </span>
    </div>
    <ng-select id="CaseSource" required #CaseCategory="ngModel" class="form-control-select"
      [items]="casecategoriesArr" bindLabel="text" bindValue="id" [(ngModel)]="casecategoryId"
      [ngModelOptions]="{ standalone: true }" placeholder="{{ 'CaseClassification' | translate }}">
    </ng-select>

  </div>
  <br>
  <br>


</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary" [disabled]="CaseCategory.invalid" (click)="AddChangeCaseCategory()">
    {{ "Save" | translate }}
  </button>
  <button type="button" class="btn btn-danger" (click)="modal.dismiss('Cross click')">
    {{ "NO" | translate }}
  </button>
</div>